import {
    AnimationBaseController,
    GameApiBase, GameRandom,
    GameStorageManager
} from "../../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { AnimationContents } from "../../AnimationContents";
import { GameLogic } from "../../../Logic/GameLogic";
import { UIControllerLeftContainer } from "./UIControllerLeftContainer";
import { UIControllerRightContainer } from "./UIControllerRightContainer";

import { ButtonController, IButtonControllerOptions } from "../../Common/ButtonController";


export interface IUIControllerOptions {
}

export class UIController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IUIControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic,
        @Inject private _arenaApi: GameApiBase) {
        super("UIController");
        console.log('UIController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.UI_SCREEN_JSON,
            libraryName: "ui",
            childControllers: {
                UILeftContainer: {
                    instanceName: "left_container",
                    model: this.$model,
                    controller: UIControllerLeftContainer,
                    options: <IUIControllerOptions>{

                    }
                },
                UIRightContainer: {
                    instanceName: "right_container",
                    model: this.$model,
                    controller: UIControllerRightContainer,
                    options: <IUIControllerOptions>{

                    },
                },
            },
            modelWatch: {

            }
        };
    }

    protected onInitialize(): void {

    }

    protected onLandscape(): void {

    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }
    protected onResize(width: number, height: number, scale: number): void {



    }
}

